import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SavedPathway } from '../../../types/pathway';
import { PathwayButton } from '../PathwayButton';
interface EditIntentModalProps {
  pathway: SavedPathway | null;
  onUpdate: () => void;
  onCancel: () => void;
}

/** Confirms the rep's first change to a saved pathway. Save or cancel. */
export function EditIntentModal({
  pathway,
  onUpdate,
  onCancel
}: EditIntentModalProps) {
  return <AnimatePresence data-id="element-1830" data-mp="124ixqt340hr0">
      {pathway && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.16
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 p-4" role="dialog" aria-modal="true" aria-labelledby="edit-intent-title" data-id="element-1831" data-mp="x43ks2mqpc9k">
          <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 8
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full max-w-md rounded-xl bg-white p-6 shadow-lg" data-id="element-1832" data-mp="2mk2xftpkhjty">
            <h2 id="edit-intent-title" className="text-lg font-bold text-gray-900" data-id="element-1833" data-mp="1klf6csdd0me">
              Change this pathway?
            </h2>
            <p className="mt-2 text-sm text-gray-600" data-id="element-1834" data-mp="351vcgyzhrees">
              You&apos;re about to change{' '}
              <span className="font-medium text-gray-900" data-id="element-1835" data-mp="3a057n9l7uf0e">{pathway.name}</span>.
            </p>

            <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-1836" data-mp="3f019p3acrwdb">
              <PathwayButton variant="secondary" fullWidth onClick={onCancel} data-id="element-1837" data-mp="3eygerck4mbex">
                Cancel
              </PathwayButton>
              <PathwayButton fullWidth onClick={onUpdate} data-id="element-1838" data-mp="2mbdlozy7ysw2">
                Save
              </PathwayButton>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}